module.exports = require("milagro-crypto-js");